import { AfterViewInit, Component, ElementRef, OnInit } from '@angular/core';
import {NavigationEnd, Router} from '@angular/router';
import {filter} from 'rxjs/operators';
import {
  Platform,
  TranslationsService,
} from '../../services/translations/translations.service';
declare var gtag: Function;

@Component({
  selector: 'app-root',
  templateUrl: './root.component.html',
  styleUrls: ['./root.component.scss'],
})
export class RootComponent implements AfterViewInit, OnInit {

  constructor(
    private readonly elementRef: ElementRef,
    private readonly translationsService: TranslationsService,
    private router: Router
  ) {}

  ngAfterViewInit(): void {
    // subscribe to router events and send page views to Google Analytics
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe((event: any )=> {
        gtag('config', 'UA-211452978-1', {'page_path': event.urlAfterRedirects});

        window.scroll({
          top: 0,
          behavior: 'smooth'
        });
      });
  }

  ngOnInit(): void {
    if (this.elementRef.nativeElement.classList.contains('mobile')) {
      this.translationsService.setPlatform(Platform.mobile);
    }
  }
}
